import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import{ ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-microsoft-rejectionform',
  templateUrl: './microsoft-rejectionform.component.html',
  styleUrls: ['./microsoft-rejectionform.component.scss']
})
export class MicrosoftRejectionformComponent implements OnInit {
public itfacilityreject_data:any={};
  constructor(public appservice:AppService, public toastr:ToastrService) { }
onApprove(){
  this.itfacilityreject_data.status='Approved';
  this.itfacilityreject_data.approvedby=this.appservice.username;
   this.appservice.postTable("api/Transaction/insert_Microsoft360_ItFacilityform",this.itfacilityreject_data).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
    //this.appservice.get_finalItFacilitygrid();
    this.appservice.goback();
  this.appservice.GetMicrosoft_Rejcet_details();
   });
  
  
}
onDecline(){
   this.itfacilityreject_data.status='Rejected';
  this.itfacilityreject_data.approvedby=this.appservice.username;
   this.appservice.postTable("api/Transaction/insert_Microsoft360_ItFacilityform",this.itfacilityreject_data).subscribe((res:any)=>{
    this.toastr.success("Decline successfully!");
    //this.appservice.get_finalItFacilitygrid();
    this.appservice.goback();
  this.appservice.GetMicrosoft_Rejcet_details();
   });
  
}
back(){
  this.appservice.goback();
  this.appservice.GetMicrosoft_Rejcet_details();
  
}
public rec:any={}
onformload(){
  this.appservice.getTable("api/Transaction/MicrosoftReject_editdata?id="+this.appservice.microsoftrejecteditdata).subscribe((res:any)=>{
    if(res!=""){
      this.itfacilityreject_data=JSON.parse(res).record[0];
      console.log("the edit data of itfacility rejection form",this.itfacilityreject_data)
      if(this.itfacilityreject_data){
        let data=JSON.parse(res).record[0];
        this.itfacilityreject_data.OD_iid=data.MD_iid;
        this.itfacilityreject_data.OD_RequesterName=data.MD_RequesterName;
        this.itfacilityreject_data.OD_EmployeeID=data.MD_EmployeeID;
        this.itfacilityreject_data.Companyname=data.MD_company_name;
        this.itfacilityreject_data.designation=data.MD_Designation;
        this.itfacilityreject_data.department=data.MD_Department;
        this.itfacilityreject_data.OD_Location=data.MD_Location;
        this.itfacilityreject_data.OD_ContactNumber=data.MD_ContactNumber;
        this.itfacilityreject_data.OD_EmailID=data.MD_EmailID;
        this.itfacilityreject_data.OD_ManagerName=data.MD_ManagerName;
        this.itfacilityreject_data.MD_BC365=data.MD_Micsoftdynamic360;
        this.itfacilityreject_data.grade=data.MD_Grade;
        this.itfacilityreject_data.fullName=data.MD_Fullname
       
      }
      //console.log("the edit data of itfacility rejection form",this.itfacilityreject_data.IR_CheckerStatus)
    }
    else{
      this.toastr.error("No data found");
    }
  });
}
  ngOnInit(): void {
    this.onformload();
  }

}
